export const state = () => {
	return {
		data: []
	}
}

export const getters = {}

export const actions = {
	async fetchOrders ({ commit }) {
		try {
			const { data } = await this.$axios.$get('/api/v1/payment/users/orders')

			this.$log.debug('[OrdersStore] Got `orders` from API', data)

			commit('setOrders', data)
		} catch (error) {
			commit('setOrders', [])
			this.$log.error('[OrdersStore] Error during `fetchOrders` action', error)
		}
	}
}

export const mutations = {
	setOrders (state, orders = []) {
		state.data = orders
	}
}
